import styled from 'styled-components';

export const UiHomeRulePage = styled.div`
	display: block;
`;